import './language-dropdown.component.scoped.scss'
import { useEffect, useRef, RefObject, useState } from 'react'
import { useLanguage } from '@/hooks/use-language/use-language.hook'
import { useMediaQuery } from '@/hub-shared'

interface Props {
  lang?: 'en' | 'pt' | 'es'
}

export const LanguageDropdown = ({ lang }: Props) => {
  const languageDropdownWrapperRef = useRef<HTMLElement>(null)
  const [open, setOpen] = useState(false)
  const languageButtonRef = useRef<HTMLButtonElement>(null)
  const isSmallScreen = useMediaQuery('(max-width: 991px)')

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        languageDropdownWrapperRef.current &&
        !languageDropdownWrapperRef.current.contains(event.target as Node) &&
        !languageButtonRef?.current?.contains(event.target as Node)
      ) {
        setOpen && setOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [languageButtonRef, languageDropdownWrapperRef])

  const { changeLang, currentLanguage, options, parseFlagByLang } = useLanguage(lang)
  return (
    <>
      {!isSmallScreen && (
        <button
          onClick={() => {
            setOpen(!open)
          }}
          className="user-language"
          ref={languageButtonRef}
        >
          <span className="item only-desktop">
            <span className={`language ${currentLanguage}`}></span>
          </span>
        </button>
      )}
      <nav className={`language-dropdown scrollbar ${isSmallScreen || open ? 'open' : ''}`} ref={languageDropdownWrapperRef}>
        <div className="language-dropdown-wrapper">
          {options.map(({ value: langValue, label }) => (
            <button
              key={langValue}
              onClick={() => {
                changeLang({ target: { value: langValue } })
                setOpen && setOpen(false)
              }}
              className={`language-option ${currentLanguage === langValue ? 'active' : ''}`}
            >
              <img src={`https://flagcdn.com/w40/${parseFlagByLang(langValue)}.png`} alt={`Flag ${label}`} />
              {label}
            </button>
          ))}
        </div>
      </nav>
    </>
  )
}
